// extracted by mini-css-extract-plugin
module.exports = {"custom_table":"topTable_custom_table__1cU-n","nodata":"topTable_nodata__1LIN5"};